import en_GB from './en_GB.json';

export default { en_GB };
